import type { AmenitiesName } from './types';

export const AmenitiesMapping: Record<string, AmenitiesName> = {
  AIR_CONDITIONING: 'air_conditionning',
  ART_GALLERY: 'corner-room',
  ATHLETICS_STADIUM: 'stadium',
  BABY_CRIB: 'baby_crib',
  BABY_SITTING: 'baby_sitting',
  BADMINTON: 'tennis',
  BAR: 'bar',
  BASKETBALL_COURT: 'other_sports_activities',
  BATH: 'bath',
  BBQ: 'food',
  BEAUTY_SALON: 'beauty_product',
  BEVERAGE_MACHINE: 'coffee_machine',
  BIKE_RACKS: 'bikrac',
  BOAT_TOURS: 'beach_water_sports',
  BODYBUILDING: 'fitness_center',
  BOOK_STORE: 'store',
  BOWLING: 'bowling',
  BREAKFAST: 'breakfast',
  BUSINESS_CENTER: 'business_center',
  CAR_LOAN_SERVICES: 'loan_smart_car',
  CHECKIN_CHECKOUT_FACILITIES: 'early_check-in_late_check-out',
  CHILD_EQUIPEMENTS: 'child_facilities',
  CHILD_FACILITIES: 'child_facilities',
  CLOTHING_STORE: 'store',
  COFFEE_MACHINE: 'coffee_machine',
  CONCIERGE: 'concierge',
  CONVENTION_CENTER: 'convention_center',
  CROQUET: 'other_sports_activities',
  CROSS_COUNTRY_SKIING: 'ski',
  CURRENCY_EXCHANGE: 'web_corner_mac',
  DART: 'darts',
  DEFAULT: 'check-small',
  DESK_EQUIPMENTS: 'web_corner_mac',
  DOWNHILL_SKIING: 'ski',
  ELECTRIC_CHARGING_TERMINAL: 'electric_charging_terminal',
  ELEVATOR: 'appartment',
  ENTERTAINMENT: 'amusement_park', // correct into 'default'
  FITNESS: 'fitness_center',
  FOOTBALL: 'other_sports_activities',
  GIFT_NEWS_SHOP: 'welcome-gift',
  GLASS_BOTTOM_BOAT: 'sea',
  GOLF: 'Golf_2',
  GOURMET_SHOP: 'beauty_product',
  GYM: 'fitness_center',
  GYMNASTICS_COURSE: 'fitness_center',
  HAIR_SALON: 'beauty_product',
  HAMMAM: 'hammam',
  HEARING_ROOM: 'hearing_room',
  HORSEBACK_RIDING: 'other_sports_activities',
  IRON: 'iron',
  JACUZZI: 'jacuzzi',
  JET_SKI: 'sea',
  JOGGING_TRACK: 'sptext',
  KARTING: 'motor',
  KAYAKING: 'beach_water_sports',
  KITCHEN: 'kitchen',
  LAUNDRY: 'cleaning_services',
  LIMOUSINE: 'car',
  LOUNGE: 'fireplace', // correct into 'bar cocktail';
  LUGGAGE_STORAGE: 'luggage',
  MASSAGE: 'massage',
  MEETING_ROOMS: 'meeting_room',
  MINI_GOLF: 'golf',
  NON_SMOKING: 'non_smoking',
  PARASAILING: 'beach_water_sports',
  PARK_24: 'parking',
  PARK_SECURE: 'parking',
  PARKING: 'parking',
  PEDAL_BOAT: 'beach_water_sports',
  PET: 'pet_welcome',
  PETANQUE: 'Sport_3',
  PHARMACY: 'Urgence',
  PLANET_21: 'durability_certification',
  POOL_TABLE: 'bill',
  POOL: 'pool',
  PORTER: 'luggage',
  PRIVATE_BEACH: 'private_beach',
  PRIVATE_JACUZZI: 'jacuzzi',
  PRIVATE_SAUNA: 'sauna',
  PRIVATIVE_BATHROOM: 'private_bathroom',
  QUAD_BIKES: 'motorcycle',
  RAFTING: 'beach_water_sports',
  REDUCED_MOBILITY_FACILITIES: 'weelchair',
  RESTAURANT: 'restaurant',
  RIVER_RAFTING: 'beach_water_sports',
  ROOM_SERVICE: 'room_service',
  SAFE_DEPOSIT: 'lockdown-24',
  SAILING: 'beach_water_sports',
  SAUNA: 'sauna',
  SCUBA_DIVING: 'Snorkeling',
  SEA_FISHING: 'Captain',
  SHOESHINE: 'shoe-polisher',
  SHOPPING_MALL: 'store',
  SHUTTLE: 'shuttle',
  SKATING_RINK: 'Patinage',
  SKI: 'ski',
  SNORKELLING: 'Snorkeling',
  SOLARIUM: 'Day',
  SPA: 'spa',
  SQUASH_COURT: 'tennis',
  TABLE_TENNIS: 'tennis',
  TANNINGSALON: 'spa',
  TEA_MACHINE: 'tea_machine',
  TENNIS: 'tennis',
  THALASSO: 'thalasso',
  THERMALSPA: 'spa',
  TURKSTEAMBATH: 'jacuzzi',
  VALETPARK: 'valet_parking',
  VOLLEYBALL: 'other_sports_activities',
  WATER_SKIING: 'ski',
  WHEELCHAIR_ACCESS: 'weelchair',
  WIFI: 'wifi',
  WIND_SURFING: 'beach_water_sports',
};
